<div
  id="device-setting-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_250px)]"
>
  <div class="tw-flex tw-mb-3">
    <div class="tw-flex tw-ml-auto tw-items-center">
      @if (hasAnyNotBulkApplied()) {
        <div class="tw-mr-4">
          <mat-error
            >「一括設定」ボタンが赤い場合は未設定のデバイスがありますので、一括設定を行ってください</mat-error
          >
        </div>
      }
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="updatedGroup.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
      id="device-setting-group-table"
      class="matp-table"
    >
      <!-- 設定グループ名 -->
      <ng-container matColumnDef="deviceSettingGroupName">
        <th class="tw-w-1/6" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            設定グループ名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="deviceSettingGroupName"
              matInput
              appAutocompleteOff
              name="deviceSettingGroupNameFilter"
              type="text"
              [(ngModel)]="deviceSettingGroupNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="devicesettinggroupname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDeviceSettingGroupNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          class="tw-w-1/6"
          mat-cell
          name="deviceSettingGroupName"
          *matCellDef="let element"
        >
          {{ element.deviceSettingGroupName }}
        </td>
      </ng-container>

      <!-- デバイス種類 -->
      <ng-container matColumnDef="deviceTypeId">
        <th class="tw-w-40" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            デバイス種類
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedDeviceType"
              name="deviceTypeFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (displayName of groupDeviceTypeDisplayNames; track displayName) {
                <mat-option [value]="displayName">{{ displayName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td
          class="tw-w-40"
          mat-cell
          name="deviceType"
          *matCellDef="let element"
        >
          {{ element.deviceTypeDisplayName }}
        </td>
      </ng-container>

      <!-- グループ説明 -->
      <ng-container matColumnDef="description">
        <th class="tw-w-1/3" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            グループ説明
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="description"
              matInput
              appAutocompleteOff
              name="descriptionFilter"
              type="text"
              [(ngModel)]="descriptionKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="description-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDescriptionFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          class="tw-w-1/3 tw-max-w-72"
          mat-cell
          name="description"
          *matCellDef="let element"
        >
          <div
            class="tw-line-clamp-2"
            #descriptionElement
            matTooltip="{{ element.description }}"
          >
            {{ element.description }}
          </div>
        </td>
      </ng-container>

      <!-- ステータス -->
      <ng-container matColumnDef="status">
        <th class="tw-w-28" mat-header-cell *matHeaderCellDef>
          <div
            mat-sort-header="bulkSettingStatus"
            class="matp-table-header-title"
          >
            ステータス
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedBulkSettingStatus"
              name="statusFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (status of bulkSettingStatusOptions; track status.value) {
                <mat-option [value]="status.value">{{
                  status.label
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td class="tw-w-28" mat-cell name="status" *matCellDef="let element">
          @if (isBulkSettingFailed(element)) {
            <a
              href="javascript:void(0)"
              (click)="openBulkSettingErrorDialog.emit(element)"
              >{{ getBulkSettingStatusLabel(element) }}</a
            >
          } @else {
            {{ getBulkSettingStatusLabel(element) }}
          }
        </td>
      </ng-container>

      <!-- 最終通信日時 -->
      <ng-container matColumnDef="lastUpdatedAt">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            最終更新日時
          </div>
        </th>
        <td mat-cell name="lastUpdatedAt" *matCellDef="let element">
          {{ element.lastUpdatedAt | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-min-w-[360px] tw-max-w-[360px]"
        >
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-[360px]">
          <div class="tw-flex tw-ml-auto">
            <button
              mat-stroked-button
              id="edit-btn"
              color="primary"
              class="tw-mr-2"
              (click)="updatedGroup.emit(element)"
              [disabled]="isGroupOperationDisabled(element)"
            >
              <mat-icon>edit</mat-icon>
              <span>編集</span>
            </button>
            <button
              mat-stroked-button
              id="delete-btn"
              color="warn"
              class="tw-mr-2"
              (click)="deletedGroup.emit(element)"
              [disabled]="isGroupOperationDisabled(element)"
            >
              <mat-icon>delete</mat-icon>
              <span>削除</span>
            </button>
            @if (isBulkSettingButtonWarning(element)) {
              <button
                mat-raised-button
                id="edit-btn"
                color="warn"
                class="tw-mr-2"
                (click)="updatedGroupDetail.emit(element)"
                [disabled]="isBulkSettingButtonDisabled(element)"
              >
                <mat-icon>settings</mat-icon>
                <span>一括設定</span>
              </button>
            } @else {
              <button
                mat-stroked-button
                id="edit-btn"
                color="primary"
                class="tw-mr-2"
                (click)="updatedGroupDetail.emit(element)"
                [disabled]="isBulkSettingButtonDisabled(element)"
              >
                <mat-icon>settings</mat-icon>
                <span>一括設定</span>
              </button>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="devicesetting-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
